// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from "vue-router";
import routers from './router/routers';
import ElementUI from 'element-ui';
import components from './components/index';
import '../theme/index.css';
import '../static/font/font.css';
import '../static/css/common.css';
import './icons';
import App from './App';
import axios from 'axios'
import store from './vuex/store'
import Print from 'vue-print-nb'
import echarts from 'echarts';
import 'echarts/theme/macarons.js';
import VueClipboard from 'vue-clipboard2'
import utiljs from '../static/js/utils'
import {baseUrl} from '../config/env'
import ElementResizeDetectorMaker from "element-resize-detector"
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css';
import './common/utils/dialogDrag.js'

//addon
import './addon/global/global.js';

// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(VueIntro);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(components);
Vue.use(Print);
Vue.use(VueClipboard);
Vue.prototype.$erd = ElementResizeDetectorMaker()
Vue.prototype.$echarts = echarts;
Vue.prototype.global = {baseurl: baseUrl}
Vue.prototype.$axios = axios
var qs = require("querystring")
axios.defaults.baseURL = baseUrl;
// // 2020/06/22
// axios.defaults.withCredentials = true;  //允许axios请求携带cookie等凭证

Vue.directive('focus', {
  inserted: function(el) {
    // 聚焦元素 如果元素配合modal使用 则需要给元素添加v-if
    el.querySelector('input').focus();
  }
});


// $.ajaxPrefilter(function (options){
//   //设置默认参数，用于初始化菜单接口权限数据
//   options.data.append('basePagePath',window.location.pathname)
// })
axios.interceptors.request.use((req) => {
  let isExportRequest = false;
  if (req.url.indexOf("download") !== -1 || req.url.indexOf("downLoad") !== -1 || req.url.indexOf("export") !== -1) {
    isExportRequest = true;
  }
  if (req.data) {
    let dataStr = typeof req.data === 'string' ? req.data : qs.stringify(req.data);
    if (dataStr.indexOf("isExport=1") !== -1 || dataStr.indexOf("export=export") !== -1) {
      isExportRequest = true;
    }
  }
  const isDebugRequest = DEBUG_INTERFACES.some(debugUrl => {
    return req.url.includes(debugUrl) || (req.baseURL + req.url).includes(debugUrl);
  });
  if (isDebugRequest) {
    isExportRequest = false;
  }
  if (isExportRequest) {
    store.commit('setExporting', true);
    if (pendingExportMarker && (Date.now() - pendingExportMarker.timestamp < 1000)) {
      createDownloadMarker(pendingExportMarker.startX, pendingExportMarker.startY);
      pendingExportMarker = null;
    }
  }
  // //设置默认参数，用于初始化菜单接口权限数据
  // if(req.data){
  //   req.data.basePagePath = window.location.pathname;
  // }else{
  //   req.data = {'basePagePath':window.location.pathname};
  // }
  if (req.method === 'post' && req.url.indexOf("upload") === -1) {
    req.data = qs.stringify(req.data);
  }
  return req;
}, (error) => Promise.reject(error));

let webUrl = "http://localhost:8081/login";//本地地址
if (process.env.NODE_ENV === 'test') {
  webUrl = "http://129.204.68.217:8088/sthpc/#/login";//测试地址
  var router = new VueRouter({
    // mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return { x: 0, y:0 };
    },
  });
} else if (process.env.NODE_ENV === 'production') {
  webUrl = "https://service.stonghr.cn/sth/#/login";//正式地址
  var router = new VueRouter({
    // mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return {x: 0, y: 0};
    },
  });
} else {
  var router = new VueRouter({
    mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return { x: 0, y:0 };
    },
  });
}
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  store.commit('showSensitiveData');
  next()
})

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  console.log(isChunkLoadFailed, '/Loading chunk (\d)+ failed/g', '路由懒加载找不到对应的moudle')
  if (isChunkLoadFailed) {
    window.location.reload();
  } else {
    console.log(error)
  }
});

var myInterceptor = axios.interceptors.response.use(function (res) {
  // 对响应数据做点什么
  if (res.data.flag == 'overdue') {
    location.href = webUrl
  } else if (res.data.flag == 'overOperation'){
    alert(res.data.message);
  } else if (res.data.flag == 'ipInvalid'){
    location.href = webUrl
  }else {
    return res;
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype.$http = axios
Vue.prototype.$utils = utiljs
Vue.prototype.qs = qs;

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.config.productionTip = false

function createDownloadMarker(startX, startY, callback) {
  const marker = document.createElement('div');
  marker.style.cssText = `
    position: fixed;
    left: ${startX}px;
    top: ${startY}px;
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, #33F, #33F);
    border-radius: 50%;
    z-index: 10000;
    pointer-events: none;
    box-shadow: 0 0 10px rgba(230, 162, 60, 0.8);
    transform: translate(-50%, -50%);
  `;
  document.body.appendChild(marker);

  const downloadBtn = document.querySelector('.sthHeader .el-icon-download');
  if (downloadBtn) {
    const btnRect = downloadBtn.getBoundingClientRect();
    const endX = btnRect.left + btnRect.width / 2;
    const endY = btnRect.top + btnRect.height / 2;

    const animation = marker.animate([
      {
        left: `${startX}px`,
        top: `${startY}px`,
        transform: 'translate(-50%, -50%) scale(1)',
        opacity: 1
      },
      {
        left: `${endX}px`,
        top: `${endY}px`,
        transform: 'translate(-50%, -50%) scale(0.3)',
        opacity: 0.8
      }
    ], {
      duration: 600,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
    });

    animation.onfinish = () => {
      marker.remove();
      if (callback) callback();
    };
  } else {
    marker.remove();
    if (callback) callback();
  }
}

let lastClickTime = 0;
let pendingExportMarker = null;
const EXPORT_KEYWORDS = ['export', 'download', '导出', '下载', '确定'];

const DEBUG_INTERFACES = [
  "/stonghr/home/downloadFinancialPersonalTaxWageDishList",
  // 在这里添加需要排除的接口路径
];

function isExportAction(target) {
  const tagName = target.tagName.toLowerCase();
  if (tagName === 'button' || tagName === 'a' || tagName === 'li') {
    const text = target.innerText || '';
    const className = target.className || '';
    const href = target.href || '';
    return EXPORT_KEYWORDS.some(keyword =>
      text.toLowerCase().includes(keyword.toLowerCase()) ||
      className.toLowerCase().includes(keyword.toLowerCase()) ||
      href.toLowerCase().includes(keyword.toLowerCase())
    );
  }
  const parent = target.closest('button, a, .el-button');
  if (parent) {
    return isExportAction(parent);
  }
  return false;
}

function checkIsExportRequest(url, data) {
  if (!url && !data) return false;
  const isDebugRequest = DEBUG_INTERFACES.some(debugUrl => url.includes(debugUrl));
  if (isDebugRequest) {
    return false;
  }
  const urlLower = url ? url.toLowerCase() : '';
  const hasExportKeyword = urlLower.includes('download') || urlLower.includes('downLoad') || urlLower.includes('export');
  if (!data) return hasExportKeyword;
  let dataStr = typeof data === 'string' ? data : qs.stringify(data);
  return hasExportKeyword || dataStr.includes('isExport=1') || dataStr.includes('export=export');
}

document.addEventListener('click', (e) => {
  const now = Date.now();
  if (now - lastClickTime < 100) return;
  lastClickTime = now;

  const target = e.target;

  if (target.tagName === 'A') {
    const href = target.href || '';
    if (href.includes('download') || href.includes('export') || href.includes('downLoad')) {
      e.preventDefault();
      store.commit('setExporting', true);
      createDownloadMarker(e.clientX, e.clientY);
      setTimeout(() => {
        window.location.href = href;
      }, 100);
      return;
    }
  }

  let buttonElement = null;
  const targetTagName = target.tagName.toUpperCase();
  const targetClassName = target.className || '';

  if (targetTagName === 'BUTTON' || targetClassName.includes('el-button') || targetClassName.includes('el-dropdown-item')) {
    buttonElement = target;
  } else {
    buttonElement = target.closest('button, .el-button, .el-dropdown-item, .sthbtn');
  }

  if (buttonElement) {
    const buttonText = (buttonElement.innerText || '').trim();
    const hasDownloadKeyword = buttonText.includes('下载') || buttonText.includes('导出');

    if (hasDownloadKeyword) {
      store.commit('setExporting', true);
      createDownloadMarker(e.clientX, e.clientY);
    }
  }

  if (isExportAction(target)) {
    pendingExportMarker = {
      startX: e.clientX,
      startY: e.clientY,
      timestamp: now
    };
  }
}, true);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: {App},
  template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js